export default __webpack_public_path__ + "static/article-budget-cheat-sheet-967517134093d6d67190d3d7491145b1.jpg";